// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics, AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import { BoardsDropdown, FilterShortcuts } from './main.tsx';

const BoardsDropdownWithAnalytics = AnalyticsEventToProps('deepDiveCardBoardsDropdown', {
	onError: 'error',
})(BoardsDropdown);
type BoardsDropdownProps = Flow.Diff<
	JSX.LibraryManagedAttributes<typeof BoardsDropdown, ComponentProps<typeof BoardsDropdown>>,
	{
		onError: JSX.LibraryManagedAttributes<
			typeof BoardsDropdown,
			ComponentProps<typeof BoardsDropdown>
		>['onError'];
	}
>;
const handleBoardsDropdownError = (analyticsEvent: UIAnalyticsEvent) => {
	analyticsEvent.update({
		action: 'error',
		actionSubject: 'boardsDropdown',
	});
	fireUIAnalytics(analyticsEvent, 'deepDiveCardBoardsDropdown');
};
const BoardsDropdownWithAnalyticsSubject = (props: BoardsDropdownProps): React.JSX.Element => (
	<BoardsDropdownWithAnalytics {...props} onError={handleBoardsDropdownError} />
);

const FilterShortcutsWithAnalytics = AnalyticsEventToProps('deepDiveCardFilterShortcuts', {
	onError: 'error',
})(FilterShortcuts);
type FilterShortcutsProps = Flow.Diff<
	JSX.LibraryManagedAttributes<typeof FilterShortcuts, ComponentProps<typeof FilterShortcuts>>,
	{
		onError: JSX.LibraryManagedAttributes<
			typeof FilterShortcuts,
			ComponentProps<typeof FilterShortcuts>
		>['onError'];
	}
>;
const handleFilterShortCutsError = (analyticsEvent: UIAnalyticsEvent) => {
	analyticsEvent.update({
		action: 'error',
		actionSubject: 'filterShortcuts',
	});
	fireUIAnalytics(analyticsEvent, 'deepDiveCardFilterShortcuts');
};
const FilterShortcutsWithAnalyticsSubject = (props: FilterShortcutsProps): React.JSX.Element => (
	<FilterShortcutsWithAnalytics {...props} onError={handleFilterShortCutsError} />
);

export {
	BoardsDropdownWithAnalyticsSubject as BoardsDropdown,
	FilterShortcutsWithAnalyticsSubject as FilterShortcuts,
};
